import { useQuery } from '@tanstack/react-query';

import {
  FetchTransactionNotesRequest,
  FetchTransactionNotesResponse,
  individualsService,
  transactionNotesService,
} from '@aslanpay/portal-common-lib';

const useFetchTransactionNotes = ({
  ids,
  transactionIds,
  startDate,
  endDate,
  query,
  sortBy,
  sort,
  page,
  size,
}: FetchTransactionNotesRequest) => {
  return useQuery<FetchTransactionNotesResponse, Error>(
    [
      'useFetchTransactionNotes',
      ids,
      transactionIds,
      startDate,
      endDate,
      query,
      sortBy,
      sort,
      page,
      size,
    ],
    async () => {
      const notes = await transactionNotesService.fetchTransactionNotes({
        ids,
        transactionIds,
        startDate,
        endDate,
        query,
        sortBy,
        sort,
        page,
        size,
      });

      const NIL_UUID = '00000000-0000-0000-0000-000000000000';
      const creatorIds = Array.from(
        new Set(
          notes.list
            .map((note) => note.createdBy)
            .filter((id) => id !== undefined && id !== NIL_UUID)
        )
      );

      const admins =
        creatorIds.length > 0
          ? await individualsService.fetchIndividuals({
              ids: creatorIds,
              role: ['ASLAN_ADMIN'],
              page: 0,
              size: 999999,
            })
          : { list: [] };

      const notesList = notes.list.map((note) => {
        const admin = admins.list.find((adm) => adm.id === note.createdBy);
        let adminName = '';
        if (admin) adminName = `${admin.firstName} ${admin.lastName}`;
        else if (note.createdBy === NIL_UUID) adminName = 'System';

        return { ...note, adminName };
      });

      return { ...notes, list: notesList };
    }
  );
};

export default useFetchTransactionNotes;
